import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { UserStammdaten } from '../../entities/stammdaten.js';
import type { RegistrationStammdatenPlugin } from '../plugin-types.js';
import { SDSalutationEnum } from './sd-stammdaten-plugin.js';

export const sdTutorRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::tutor-sd',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new SDTutorStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(SDTutorStammdaten.fields).filter(
      it => !['_id', '_class', 'userID', 'institutionID'].includes(it),
    );
  },
  classType: () => SDTutorStammdaten,
};

export enum SDTutorInstitutionEnum {
  SDRECHT = 'SDRECHT',
  SDWIRTSCHAFT = 'SDWIRTSCHAFT',
  SDGESELLSCHAFT = 'SDGESELLSCHAFT',
  SDERZIEHUNG = 'SDERZIEHUNG',
  SDPSYCHOLOGIE = 'SDPSYCHOLOGIE',
  SDEVANG_THEOLOGIE = 'SDEVANG_THEOLOGIE',
  SDKATH_THEOLOGIE = 'SDKATH_THEOLOGIE',
  SDPHILOSOPHIE = 'SDPHILOSOPHIE',
  SDSPRACHEN = 'SDSPRACHEN',
  SDNEU_PHILOLOGIE = 'SDNEU_PHILOLOGIE',
  SDGEO = 'SDGEO',
  SDINFORMATIK = 'SDINFORMATIK',
  SDPHYSIK = 'SDPHYSIK',
  SDCHEMIE = 'SDCHEMIE',
  SDBIOLOGIE = 'SDBIOLOGIE',
  SDMEDIZIN = 'SDMEDIZIN',
  SDEXTERN = 'SDEXTERN',
  SDOTHERS = 'SDOTHERS',
}
registerEnum({ enum: SDTutorInstitutionEnum, name: 'SDTutorInstitutionEnum' });

@Entity()
export class SDTutorStammdaten extends UserStammdaten {
  static override _class = 'SDTutorStammdaten';

  override getTranslationNamespace() {
    return 'sd-tutor';
  }

  @Field(type => String, { default: v => v ?? SDSalutationEnum.SDHERR })
  salutation: Maybe<String>;

  @validate(nonOptional())
  @Field(type => DateTime)
  birthday: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(type => SDTutorInstitutionEnum)
  department: Maybe<SDTutorInstitutionEnum>;

  @validate(nonOptional())
  @Field(type => String)
  tutoriumsTitle: Maybe<string>;

  @Field(type => String)
  unterstuetzungsBedarf: Maybe<string>;
}
